import React from 'react';

import { EditOrder } from 'pages/Order/components';
import { Order } from 'constants/interface';
import { useOrganizationContext } from 'hooks/contextOrganization';

interface ProposalDetailProps {
  order: Order
}

const ProposalDetail = ({
  order,
}: ProposalDetailProps): JSX.Element => {
  const organizationContext = useOrganizationContext();
  return (
    <>
      {
        organizationContext.organization === undefined ? (
          null
        ) : (
          <EditOrder
            activeOrder={order}
            selectedOrg={organizationContext.organization}
          />
        )
      }
    </>
  );
};

export default ProposalDetail;
